import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-652c0395"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-search-dialog" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isShowSearch,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowSearch) = $event)),
      width: "300px",
      "destroy-on-close": "",
      modal: false,
      fullscreen: "",
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_autocomplete, {
          modelValue: _ctx.menuQuery,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuQuery) = $event)),
          "fetch-suggestions": _ctx.menuSearch,
          placeholder: _ctx.$t('message.user.searchPlaceholder'),
          "prefix-icon": "el-icon-search",
          ref: "layoutMenuAutocompleteRef",
          onSelect: _ctx.onHandleSelect,
          onBlur: _ctx.onSearchBlur
        }, {
          default: _withCtx(({ item }) => [
            _createElementVNode("div", null, [
              _createElementVNode("i", {
                class: _normalizeClass([item.meta.icon, "mr10"])
              }, null, 2),
              _createTextVNode(_toDisplayString(_ctx.$t(item.meta.title)), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "fetch-suggestions", "placeholder", "onSelect", "onBlur"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}